import { additionalMarketingCopy } from './marketingAdditionalTranslations';

const baseExtendedCopy = {
  "zh": {
    "hero": [
      [
        "MecoPay 是一个完整的电子商务解决方案——",
        "拥有强大的支付网关",
        "和一个无代码网站构建器。"
      ],
      [
        "使用您自定义的网站或",
        "我们的无代码网站（带 API 和链接）",
        "并通过社交媒体支付链接接受付款。"
      ],
      [
        "只需几次点击即可创建网站，",
        "添加自定义域名，",
        "并建立您的数字身份。"
      ],
      [
        "从社交媒体接收自动订单",
        "使用 AI 代理聊天机器人",
        "（适用于无代码网站用户）。"
      ],
      [
        "将快递 API 添加到我们的平台，",
        "一键确认订单，",
        "并直接发送给快递。"
      ]
    ],
    "features": {
      "no-code-website": [
        "无需编写代码即可创建和发布电子商务、教育、博客或新闻网站。",
        "示例：从课程卖家仪表板发布登陆页和产品帖子。"
      ],
      "custom-domain": [
        "连接您自己的域名，并通过更快的路由构建专业的数字身份。",
        "示例：您的商店运行在 www.acme.com，而不是平台子域名。"
      ],
      "capi": [
        "通过服务器端发送转化事件以实现可靠的活动衡量（CAPI）。",
        "示例：一次购买事件从服务器发送到广告平台。"
      ],
      "personal-mfs": [
        "自动化支持的个人 MFS 付款验证。",
        "示例：个人 MFS 付款与网站订单匹配。"
      ],
      "local-gateway": [
        "为本地客户连接本地支付方式。",
        "示例：本地买家通过区域网关完成结账。"
      ],
      "international-gateway": [
        "为全球客户连接国际支付方式。",
        "示例：海外买家使用全球方式完成结账。"
      ],
      "notifications": [
        "向客户和商户发送付款和订单更新。",
        "示例：付款成功触发商户提醒并更新客户。"
      ],
      "courier": [
        "将已确认订单自动发送到支持的快递工作流。",
        "示例：已确认的货到付款订单准备交付给快递。"
      ],
      "business-email": [
        "在您自己的品牌域上发送和接收专业电子邮件。",
        "示例：sales@acme.com 接收咨询，support@acme.com 回复。"
      ]
    },
    "sections": {
      "scale": [
        "无限扩展",
        "持有 Trade License 和 TIN 的企业可以通过商户 MFS、银行或银行卡接收无限付款——为数字商务实现全自动处理。"
      ],
      "personal": [
        "没有 Trade License？",
        "使用 Personal MFS 开始接收付款，创建您的数字身份，轻松开启电子商务。"
      ],
      "physical": [
        "实体店与在线",
        "保留数字记录并从您的实体店或办公室在线销售，支持直接 QR 支付。"
      ]
    },
    "ticker": "1. Personal MFS：适用于没有 Trade License 或 TIN 的用户。可销售数字和实物商品并接受预付款。 • 2. Merchant MFS/Bank/Card：适用于持牌商户。接收无限付款并销售数字和实物商品。 • 3. Bangla QR：在实体店接受 QR 支付，同时保留数字记录并在线销售。"
  },
  "de": {
    "hero": [
      [
        "MecoPay ist eine komplette E‑Commerce‑Lösung—",
        "mit leistungsstarken Zahlungs‑Gateways",
        "und einem No‑Code Website‑Builder."
      ],
      [
        "Verwenden Sie Ihre eigene Website oder",
        "unsere No‑Code‑Website mit APIs und Links",
        "und akzeptieren Sie Zahlungen über Social‑Media‑Zahlungslinks."
      ],
      [
        "Erstellen Sie eine Website mit wenigen Klicks,",
        "fügen Sie eine eigene Domain hinzu,",
        "und bauen Sie Ihre digitale Identität auf."
      ],
      [
        "Empfangen Sie automatisierte Bestellungen aus Social Media",
        "mit einem AI Agent Chatbot",
        "(für No‑Code‑Website‑Nutzer)."
      ],
      [
        "Fügen Sie eine Kurier‑API zu unserer Plattform hinzu,",
        "bestätigen Sie Bestellungen mit einem Klick,",
        "und senden Sie sie direkt an den Kurier."
      ]
    ],
    "features": {
      "no-code-website": [
        "Erstellen und veröffentlichen Sie E‑Commerce‑, Bildungs‑, Blog‑ oder Nachrichtenseiten ohne Programmierung.",
        "Beispiel: Veröffentlichen Sie eine Landingpage und einen Produktbeitrag aus dem Kurs‑Verkäufer‑Dashboard."
      ],
      "custom-domain": [
        "Verbinden Sie Ihre eigene Domain und schaffen Sie mit schnellerem Routing eine professionelle digitale Identität.",
        "Beispiel: Ihr Shop läuft unter www.acme.com statt auf einer Plattform‑Subdomain."
      ],
      "capi": [
        "Senden Sie Conversion‑Events serverseitig für zuverlässige Kampagnenmessung (CAPI).",
        "Beispiel: Ein Kauf‑Event wird vom Server an die Werbeplattform gesendet."
      ],
      "personal-mfs": [
        "Automatisieren Sie die Verifikation unterstützter persönlicher MFS‑Zahlungen.",
        "Beispiel: Eine persönliche MFS‑Zahlung wird der Website‑Bestellung zugeordnet."
      ],
      "local-gateway": [
        "Verbinden Sie lokale Zahlungsmethoden für regionale Kunden.",
        "Beispiel: Ein lokaler Käufer schließt den Checkout über ein regionales Gateway ab."
      ],
      "international-gateway": [
        "Verbinden Sie internationale Zahlungsmethoden für Kunden weltweit.",
        "Beispiel: Ein Käufer aus dem Ausland schließt den Checkout mit einer globalen Methode ab."
      ],
      "notifications": [
        "Senden Sie Zahlungs‑ und Bestellupdates an Kunden und Händler.",
        "Beispiel: Zahlungserfolg löst eine Händler‑Benachrichtigung und ein Kunden‑Update aus."
      ],
      "courier": [
        "Senden Sie bestätigte Bestellungen automatisch in einen unterstützten Kurier‑Workflow.",
        "Beispiel: Eine bestätigte Nachnahme‑Bestellung wird für die Übergabe an den Kurier vorbereitet."
      ],
      "business-email": [
        "Senden und empfangen Sie professionelle E‑Mails unter Ihrer eigenen Marken‑Domain.",
        "Beispiel: sales@acme.com erhält Anfragen und support@acme.com antwortet."
      ]
    },
    "sections": {
      "scale": [
        "Unbegrenzte Skalierung",
        "Unternehmen mit Trade License und TIN können unbegrenzt Zahlungen über Merchant MFS, Bank oder Karte erhalten — vollständig automatisiert für digitalen Handel."
      ],
      "personal": [
        "Keine Trade License?",
        "Beginnen Sie Zahlungen mit Personal MFS zu empfangen, erstellen Sie Ihre digitale Identität und starten Sie E‑Commerce ohne unnötige Komplexität."
      ],
      "physical": [
        "Physisches Geschäft und Online",
        "Führen Sie digitale Aufzeichnungen und verkaufen Sie online aus Ihrem physischen Geschäft oder Büro mit direkter QR‑Zahlungsunterstützung."
      ]
    },
    "ticker": "1. Personal MFS: für Nutzer ohne Trade License oder TIN. Verkaufen Sie digitale und physische Produkte und akzeptieren Sie Vorauszahlungen. • 2. Merchant MFS/Bank/Card: für lizenzierte Händler. Empfangen Sie unbegrenzte Zahlungen und verkaufen Sie digitale und physische Produkte. • 3. Bangla QR: Akzeptieren Sie QR‑Zahlungen in physischen Geschäften und führen Sie digitale Aufzeichnungen, während Sie online verkaufen."
  },
  "ja": {
    "hero": [
      [
        "MecoPayは包括的なeコマースソリューションです—",
        "強力な決済ゲートウェイを備え、",
        "ノーコードのウェブサイトビルダーを提供します。"
      ],
      [
        "カスタムサイトを使うか、",
        "APIとリンクを備えた当社のノーコードサイトを使い、",
        "ソーシャルメディアの支払いリンクで決済を受け付けます。"
      ],
      [
        "数クリックでウェブサイトを作成、",
        "カスタムドメインを追加し、",
        "デジタルアイデンティティを構築できます。"
      ],
      [
        "ソーシャルメディアから自動注文を受け取り、",
        "AI Agent Chatbotで対応します",
        "（ノーコードサイト利用者向け）。"
      ],
      [
        "当社プラットフォームに宅配APIを追加し、",
        "ワンクリックで注文を確定、",
        "そのまま宅配業者へ送れます。"
      ]
    ],
    "features": {
      "no-code-website": [
        "コーディング不要でEC、教育、ブログ、ニュースサイトを作成・公開できます。",
        "例：コース販売者のダッシュボードからランディングページと商品投稿を公開。"
      ],
      "custom-domain": [
        "独自ドメインを接続して、より高速なルーティングでプロフェッショナルなデジタルアイデンティティを構築。",
        "例：ショップがプラットフォームのサブドメインではなく www.acme.com で動作。"
      ],
      "capi": [
        "CAPI をサーバー側から送信してキャンペーンの測定を確実に。",
        "例：購入イベントがサーバーから広告プラットフォームへ送信される。"
      ],
      "personal-mfs": [
        "対応する個人 MFS 決済の照合を自動化。",
        "例：個人 MFS 決済がウェブサイトの注文と照合される。"
      ],
      "local-gateway": [
        "地域の顧客のためにローカル決済手段を接続。",
        "例：現地の購入者が地域ゲートウェイでチェックアウトを完了。"
      ],
      "international-gateway": [
        "世界中の顧客向けに国際的な決済手段を接続。",
        "例：海外の購入者がグローバル手段でチェックアウトを完了。"
      ],
      "notifications": [
        "顧客と販売者に支払い・注文の更新を送信。",
        "例：支払い成功で販売者に通知、顧客に更新が届く。"
      ],
      "courier": [
        "確定した注文を対応する宅配ワークフローへ自動的に送信。",
        "例：確定した代金引換注文が宅配引き渡し用に準備される。"
      ],
      "business-email": [
        "独自のブランドドメインでプロフェッショナルなメールを送受信。",
        "例：sales@acme.com が問い合わせを受け、support@acme.com が返信。"
      ]
    },
    "sections": {
      "scale": [
        "無制限のスケーリング",
        "Trade License と TIN を持つ事業者は Merchant MFS、銀行、カードを通じて無制限の支払いを受け取れます—デジタルコマース向けに完全自動化。"
      ],
      "personal": [
        "Trade License がない？",
        "Personal MFS で支払い受け取りを開始し、デジタルアイデンティティを作って、複雑さを気にせずにeコマースを始めましょう。"
      ],
      "physical": [
        "実店舗とオンライン",
        "デジタル記録を保持し、実店舗やオフィスからオンラインで販売、直接 QR 支払いに対応。"
      ]
    },
    "ticker": "1. Personal MFS: Trade License や TIN を持たないユーザー向け。デジタル・物理商品の販売と前払金の受け取りが可能。 • 2. Merchant MFS/Bank/Card: ライセンスを持つ販売者向け。無制限の支払いを受け取り、デジタル・物理商品を販売可能。 • 3. Bangla QR: 実店舗で QR 決済を受け付け、オンライン販売しながらデジタル記録を保持。"
  },
  "ko": {
    "hero": [
      [
        "MecoPay는 완전한 전자상거래 솔루션입니다—",
        "강력한 결제 게이트웨이와",
        "노코드 웹사이트 빌더를 제공합니다."
      ],
      [
        "맞춤형 웹사이트를 사용하거나",
        "API와 링크가 포함된 당사의 노코드 웹사이트를 사용하여",
        "소셜 미디어 결제 링크로 결제를 받으세요."
      ],
      [
        "몇 번의 클릭으로 웹사이트를 만들고,",
        "맞춤 도메인을 추가하며,",
        "디지털 아이덴티티를 구축하세요."
      ],
      [
        "소셜 미디어로부터 자동화된 주문을 받고",
        "AI Agent Chatbot으로 응답합니다",
        "(노코드 웹사이트 사용자용)."
      ],
      [
        "당사 플랫폼에 택배 API를 추가하고,",
        "한 번의 클릭으로 주문을 확인한 뒤,",
        "직접 택배사로 전송하세요."
      ]
    ],
    "features": {
      "no-code-website": [
        "코딩 없이 전자상거래, 교육, 블로그 또는 뉴스 사이트를 생성하고 게시하세요.",
        "예: 강좌 판매자 대시보드에서 랜딩 페이지와 제품 게시물을 게시합니다."
      ],
      "custom-domain": [
        "자신의 도메인을 연결하고 더 빠른 라우팅으로 전문적인 디지털 아이덴티티를 구축하세요.",
        "예: 플랫폼 서브도메인 대신 www.acme.com에서 스토어가 운영됩니다."
      ],
      "capi": [
        "신뢰할 수 있는 캠페인 측정을 위해 서버 측에서 전환 이벤트를 전송하세요 (CAPI).",
        "예: 구매 이벤트가 서버에서 광고 플랫폼으로 전송됩니다."
      ],
      "personal-mfs": [
        "지원되는 개인 MFS 결제 검증을 자동화하세요.",
        "예: 개인 MFS 결제가 웹사이트 주문과 일치합니다."
      ],
      "local-gateway": [
        "지역 고객을 위해 로컬 결제 수단을 연결하세요.",
        "예: 지역 구매자가 지역 게이트웨이를 통해 결제 완료."
      ],
      "international-gateway": [
        "전 세계 고객을 위해 국제 결제 수단을 연결하세요.",
        "예: 해외 구매자가 글로벌 수단으로 결제 완료."
      ],
      "notifications": [
        "고객과 판매자에게 결제 및 주문 업데이트를 전송하세요.",
        "예: 결제 성공 시 판매자 알림과 고객 업데이트가 트리거됩니다."
      ],
      "courier": [
        "확정된 주문을 지원되는 택배 워크플로로 자동 전송하세요.",
        "예: 확정된 착불 주문이 택배 인계 준비됩니다."
      ],
      "business-email": [
        "자사 브랜드 도메인에서 전문 이메일을 보내고 받으세요.",
        "예: sales@acme.com이 문의를 받고 support@acme.com이 회신합니다."
      ]
    },
    "sections": {
      "scale": [
        "무제한 확장",
        "Trade License 및 TIN을 보유한 기업은 Merchant MFS, 은행 또는 카드로 무제한 결제를 수취할 수 있습니다—디지털 상거래를 위해 완전 자동화됩니다."
      ],
      "personal": [
        "Trade License가 없으신가요?",
        "Personal MFS로 결제 수취를 시작하고 디지털 아이덴티티를 만들며 불필요한 복잡성 없이 전자상거래를 시작하세요."
      ],
      "physical": [
        "오프라인 매장과 온라인",
        "디지털 기록을 유지하고 오프라인 매장 또는 사무실에서 온라인 판매, 직접 QR 결제 지원."
      ]
    },
    "ticker": "1. Personal MFS: Trade License 또는 TIN이 없는 사용자를 위한 서비스. 디지털 및 물리적 상품을 판매하고 선불 결제를 받으세요. • 2. Merchant MFS/Bank/Card: 라이선스 보유 상인을 위한 서비스. 무제한 결제를 수취하고 디지털 및 물리적 상품을 판매하세요. • 3. Bangla QR: 오프라인 매장에서 QR 결제를 수락하고 온라인으로 판매하면서 디지털 기록을 유지하세요."
  },
  "ru": {
    "hero": [
      [
        "MecoPay — это полноценное e‑commerce решение—",
        "с мощными платежными шлюзами",
        "и конструктором сайтов без кода."
      ],
      [
        "Используйте собственный сайт или",
        "наш ноу‑код сайт с API и ссылками",
        "и принимайте платежи через ссылки для оплаты в социальных сетях."
      ],
      [
        "Создайте сайт в несколько кликов,",
        "добавьте собственный домен,",
        "и сформируйте свою цифровую идентичность."
      ],
      [
        "Получайте автоматические заказы из социальных сетей",
        "с AI Agent Chatbot",
        "(для пользователей ноу‑код сайта)."
      ],
      [
        "Добавьте курьерский API на нашу платформу,",
        "подтвердите заказы в один клик,",
        "и отправляйте их напрямую в курьерскую службу."
      ]
    ],
    "features": {
      "no-code-website": [
        "Создавайте и публикуйте сайты для e‑commerce, образования, блогов или новостей без программирования.",
        "Пример: опубликовать лендинг и пост с продуктом из панели продавца курсов."
      ],
      "custom-domain": [
        "Подключите собственный домен и создайте профессиональную цифровую идентичность с более быстрым маршрутом.",
        "Пример: ваш магазин работает на www.acme.com вместо субдомена платформы."
      ],
      "capi": [
        "Отправляйте события конверсии сервер‑сайд для надежного измерения кампаний (CAPI).",
        "Пример: событие покупки отправляется с сервера на рекламную платформу."
      ],
      "personal-mfs": [
        "Автоматизируйте проверку поддерживаемых личных MFS‑платежей.",
        "Пример: личный MFS‑платеж сопоставляется с заказом на сайте."
      ],
      "local-gateway": [
        "Подключайте локальные методы оплаты для региональных клиентов.",
        "Пример: локальный покупатель завершает оформление через региональный шлюз."
      ],
      "international-gateway": [
        "Подключайте международные методы оплаты для клиентов по всему миру.",
        "Пример: зарубежный покупатель завершает оплату с помощью глобального метода."
      ],
      "notifications": [
        "Отправляйте клиентам и торговцам уведомления о платежах и заказах.",
        "Пример: успешный платёж вызывает оповещение торговцу и обновление для клиента."
      ],
      "courier": [
        "Автоматически отправляйте подтверждённые заказы в поддерживаемый курьерский workflow.",
        "Пример: подтверждённый наложенный платеж готовят к передаче курьеру."
      ],
      "business-email": [
        "Отправляйте и получайте профессиональные письма на собственном брендированном домене.",
        "Пример: sales@acme.com получает запросы, support@acme.com отвечает."
      ]
    },
    "sections": {
      "scale": [
        "Неограниченное масштабирование",
        "Компании с Trade License и TIN могут получать неограниченные платежи через Merchant MFS, банк или карту — полностью автоматизировано для цифровой торговли."
      ],
      "personal": [
        "Нет Trade License?",
        "Начните принимать платежи с Personal MFS, создайте цифровую идентичность и начните e‑commerce без лишней сложности."
      ],
      "physical": [
        "Физический магазин и онлайн",
        "Ведите цифровые записи и продавайте онлайн из вашего физического магазина или офиса с поддержкой прямых QR‑платежей."
      ]
    },
    "ticker": "1. Personal MFS: для пользователей без Trade License или TIN. Продавайте цифровые и физические товары и принимайте предоплаты. • 2. Merchant MFS/Bank/Card: для лицензированных продавцов. Получайте неограниченные платежи и продавайте цифровые и физические товары. • 3. Bangla QR: принимайте QR‑платежи в физических магазинах и ведите цифровой учёт при онлайн‑продаже."
  },
  "tr": {
    "hero": [
      [
        "MecoPay, eksiksiz bir e‑ticaret çözümüdür—",
        "güçlü ödeme ağ geçitleriyle",
        "ve kodsuz (no‑code) bir web sitesi oluşturucusuyla."
      ],
      [
        "Kendi özel sitenizi veya",
        "API'ler ve bağlantılar içeren kodsuz web sitemizi kullanın",
        "ve sosyal medya ödeme bağlantılarıyla ödemeleri kabul edin."
      ],
      [
        "Birkaç tıklamayla bir web sitesi oluşturun,",
        "özel bir alan adı ekleyin,",
        "ve dijital kimliğinizi oluşturun."
      ],
      [
        "Sosyal medyadan otomatik sipariş alın",
        "AI Agent Chatbot ile",
        "(kodsuz web sitesi kullanıcıları için)."
      ],
      [
        "Kargo API'sini platformumuza ekleyin,",
        "siparişleri tek tıklamayla onaylayın,",
        "ve doğrudan kargoya gönderin."
      ]
    ],
    "features": {
      "no-code-website": [
        "Kod yazmadan e‑ticaret, eğitim, blog veya haber siteleri oluşturun ve yayınlayın.",
        "Örnek: kurs satıcı kontrol panelinden bir açılış sayfası ve ürün gönderisi yayınlayın."
      ],
      "custom-domain": [
        "Kendi alan adınızı bağlayın ve daha hızlı yönlendirme ile profesyonel bir dijital kimlik oluşturun.",
        "Örnek: mağazanız platform alt alanı yerine www.acme.com üzerinde çalışır."
      ],
      "capi": [
        "Güvenilir kampanya ölçümü için dönüşüm olaylarını sunucu tarafında gönderin (CAPI).",
        "Örnek: bir satın alma olayı sunucudan reklam platformuna gönderilir."
      ],
      "personal-mfs": [
        "Desteklenen kişisel MFS ödeme doğrulamasını otomatikleştirin.",
        "Örnek: bir kişisel MFS ödemesi web sitesi siparişiyle eşleştirilir."
      ],
      "local-gateway": [
        "Bölgesel müşteriler için yerel ödeme yöntemlerini bağlayın.",
        "Örnek: bir yerel alıcı bölgesel bir ağ geçidi üzerinden ödeme tamamlar."
      ],
      "international-gateway": [
        "Dünya çapındaki müşteriler için uluslararası ödeme yöntemlerini bağlayın.",
        "Örnek: yurt dışındaki bir alıcı küresel bir yöntemle ödeme tamamlar."
      ],
      "notifications": [
        "Müşterilere ve satıcılara ödeme ve sipariş güncellemeleri gönderin.",
        "Örnek: ödeme başarılı olduğunda satıcı uyarısı ve müşteri güncellemesi tetiklenir."
      ],
      "courier": [
        "Onaylanmış siparişleri desteklenen bir kurye iş akışına otomatik olarak gönderin.",
        "Örnek: onaylanmış kapıda ödeme siparişi kurye teslimine hazırlanır."
      ],
      "business-email": [
        "Kendi marka alan adınızla profesyonel e‑postalar gönderin ve alın.",
        "Örnek: sales@acme.com gelen soruları alır ve support@acme.com cevap verir."
      ]
    },
    "sections": {
      "scale": [
        "Sınırsız Ölçeklenme",
        "Trade License ve TIN'e sahip işletmeler Merchant MFS, banka veya kart aracılığıyla sınırsız ödeme alabilir—dijital ticaret için tam otomasyon."
      ],
      "personal": [
        "Trade License yok mu?",
        "Personal MFS ile ödeme almaya başlayın, dijital kimliğinizi oluşturun ve gereksiz karmaşıklık olmadan e‑ticarete başlayın."
      ],
      "physical": [
        "Fiziksel Mağaza ve Online",
        "Dijital kayıtlar tutun ve fiziksel mağazanızdan veya ofisinizden doğrudan QR ödemeyi destekleyerek online satış yapın."
      ]
    },
    "ticker": "1. Personal MFS: Trade License veya TIN'i olmayan kullanıcılar için. Dijital ve fiziki ürünler satın ve ön ödeme kabul et. • 2. Merchant MFS/Bank/Card: lisanslı satıcılar için. Sınırsız ödeme alın ve dijital ile fiziki ürünler satın. • 3. Bangla QR: fiziksel mağazalarda QR ödemelerini kabul edin ve online satış yaparken dijital kayıtları tutun."
  }
} as const;

export const extendedCopy = { ...baseExtendedCopy, ...additionalMarketingCopy } as const;
